import request from "@utils/request";

export function updatePassword (query) {
    return request({
        url: "security/reset-password",
        method: "post",
        data: query
    });
}
